import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CMSActions from "./store/actions";
import TextoYTitulo from "@components/TextoYTitulo/TextoYTitulo";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import CardTypeFolder from "@components/CardTypeFolder/CardTypeFolder";
import "./Contactenos.css";

const BORDER_TOP_COLOR = "#d7de00";

const Contactenos = (props) => {
  const dispatch = useDispatch();

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);

  const { contactenos } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    dispatch(CMSActions.getContactenos());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defRoute = rutas?.filter((route) => route?.name === "Contáctenos");

  const contactenosItems = (
    <>
      {contactenos && (
        <>
          <TextoYTitulo
            title={contactenos?.accontactenos[0]?.titulo}
            text={contactenos?.accontactenos[0]?.informacion?.html}
            borderTopColor={BORDER_TOP_COLOR}
          />
          <div className="contact-container">
            {contactenos?.accontactenos[0]?.bag.contentItems &&
              contactenos?.accontactenos[0]?.bag.contentItems.map(
                (detail, index) => (
                  <CardTypeFolder
                    key={index}
                    title={detail.title}
                    description={detail.description.html}
                    borderTopColor={BORDER_TOP_COLOR}
                  />
                )
              )}
          </div>
        </>
      )}
    </>
  );

  return (
    <>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.h1} />
      {contactenosItems}
    </>
  );
};

export default Contactenos;
